
<template>
    <h1>Morten sin component</h1>
    <p>Dette er {{ myName }} sin component</p>
    <input v-model="myName" />
    <button @click="myButton" >Klikk meg</button>

    </template>

<script>
export default {
    name: "myName",
    data() {
        return{
            myName: 'Morten'
        };
       
    },
    methods: {
        myButton() {  
            this.myName = 'Knapp';
        } 
    }
    
}
</script>